import { useMemo } from 'react'
import getAPIDomain from '@signal/utils/env/apiDomain'
import isStorybook from '@signal/utils/env/isStorybook'
import isTest from '@signal/utils/env/isTest'
import useSWRWithCache from '../swr/hooks'
import { replaceCacheURL } from '../swr/utils'
import { API_VERSION, API_SEGMENT } from './constants'
import mockData from './mockData.json'
import { hydrateServiceMenuIcons } from './utils'

const DEFAULT_MENU_ICON_PROPS = {
  color: 'primary'
}

export function getMenuServiceURL({ accountId }) {
  const itemsBaseUrl = `${getAPIDomain(API_SEGMENT)}/v${API_VERSION}/items`
  return accountId ? `${itemsBaseUrl}/${accountId}` : itemsBaseUrl
}

// use this function to actually use the menu data from a React component w/suspense loading state
export function useMenuService({
  accountId,
  baseUrl,
  iconProps = DEFAULT_MENU_ICON_PROPS,
  useMockData = isStorybook() || isTest()
}) {
  const url = useMemo(() => getMenuServiceURL({ accountId }), [accountId])
  if (useMockData) {
    const mockDataForAccount = JSON.parse(
      JSON.stringify(mockData).replace(/:accountId/g, accountId)
    )
    replaceCacheURL(url, '', mockDataForAccount)
  }
  const rawMenu = useSWRWithCache({
    url,
    context: 'useMenuService'
  })
  return rawMenu && hydrateServiceMenuIcons(rawMenu.items, iconProps, baseUrl)
}

export default useMenuService
